<template>
  <div class="city-agent-view">
    <div class="pink-dec pink-dec1" />
    <div class="pink-dec pink-dec2" />
    <div class="pink-dec pink-dec3" />
    <div class="pink-dec pink-dec4" />
    <div class="home-dec1" />
    <div class="home-dec2" />
    <div class="home-dec3" />
    <Banner :image-list="cityBannerImages" :image-alt-list="cityBannerAltList" :duration="5000">
      <div class="banner-buttons">
        <div class="btn" @click="handleApplyAgent">立即申请代理</div>
        <div class="btn" @click="handleLearnAdvantages">了解代理优势</div>
      </div>
    </Banner>
    <CityContent1 />
    <CityContent2 ref="cityContent2" />
    <CityContent3 />
    <ApplyAgentForm ref="applyForm" />
    <!-- 悬浮二维码按钮 -->
    <div class="float-qrcode-wrapper">
      <FloatQrcode />
    </div>
    <HomeFooter v-if="showFooter" />
  </div>
</template>

<script>
import Banner from '@/components/Banner/Banner.vue';
import FloatQrcode from '@/components/FloatQrcode/FloatQrcode.vue';
import HomeFooter from '@/components/HomeFooter/HomeFooter.vue';
import CityContent1 from './CityContent1.vue';
import CityContent2 from './CityContent2.vue';
import CityContent3 from './CityContent3.vue';
import ApplyAgentForm from './ApplyAgentForm.vue';

export default {
  name: 'CityAgentView',
  components: {
    Banner,
    CityContent1,
    CityContent2,
    CityContent3,
    ApplyAgentForm,
    FloatQrcode,
    HomeFooter,
  },
  computed: {
    showFooter() {
      // 从当前路由和父路由中查找 showFooter
      const { matched } = this.$route;
      for (let i = matched.length - 1; i >= 0; i -= 1) {
        if (matched[i].meta?.showFooter !== undefined) {
          return matched[i].meta.showFooter;
        }
      }
      return false;
    },
  },
  data() {
    return {
      cityBannerImages: [
        'https://ustatic.hudongmiao.com/miao/common/city-banner_176786410047044f764.webp',
      ],
      cityBannerAltList: ['松鼠互娱酒吧霸屏点歌软件系统招募城市代理'],
    };
  },
  methods: {
    handleApplyAgent() {
      // 滚动到申请表位置
      this.$nextTick(() => {
        if (this.$refs.applyForm && this.$refs.applyForm.$el) {
          const element = this.$refs.applyForm.$el;
          const headerHeight = 62; // 固定头部高度
          const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementTop - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      });
    },
    handleLearnAdvantages() {
      // 滚动到代理优势位置
      this.$nextTick(() => {
        if (this.$refs.cityContent2 && this.$refs.cityContent2.$el) {
          const element = this.$refs.cityContent2.$el;
          const headerHeight = 62; // 固定头部高度
          const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementTop - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.city-agent-view {
  position: relative;
  z-index: 0; // 创建局部层叠上下文，方便控制内部层级
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  padding-top: 62px;
  background: #000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;

  .pink-dec {
    position: absolute;
    z-index: 0; // 在 city-agent-view 背景之上，但低于其他内容
    pointer-events: none; // 不影响鼠标/点击事件
    width: 589px;
    height: 588px;
    background: rgba(221, 1, 255, 1);
    filter: blur(369px);
  }

  .home-dec1 {
    position: absolute;
    z-index: 1; // 高于粉色模糊背景，但低于主体内容
    pointer-events: none;
    width: 171px;
    height: 525px;
    background: url('~@/assets/image/home-dec1.png') no-repeat center center;
    background-size: contain;
    top: 850px;
    right: 0;
  }

  .home-dec2 {
    position: absolute;
    z-index: 1;
    pointer-events: none;
    width: 291px;
    height: 850px;
    background: url('~@/assets/image/home-dec2.png') no-repeat center center;
    background-size: contain;
    top: 1350px;
    left: -150px;
  }

  .home-dec3 {
    position: absolute;
    z-index: 1; // 高于粉色模糊背景，但低于主体内容
    pointer-events: none;
    width: 222px;
    height: 682px;
    background: url('~@/assets/image/home-dec1.png') no-repeat center center;
    background-size: contain;
    top: 2000px;
    right: -100px;
  }

  .pink-dec1 {
    top: 900px;
    right: -400px;
  }

  .pink-dec2 {
    top: 1600px;
    left: -400px;
    filter: blur(469px);
  }

  .pink-dec3 {
    top: 2100px;
    right: -450px;
    filter: blur(369px);
  }

  .pink-dec4 {
    top: 3800px;
    right: -400px;
    filter: blur(369px);
    // 位置由用户调整
  }

  // 让除粉色背景、home-dec1、home-dec2、home-dec3 和浮动二维码容器以外的所有直接子元素都在其之上
  >*:not(.pink-dec):not(.home-dec1):not(.home-dec2):not(.home-dec3):not(.float-qrcode-wrapper) {
    position: relative;
    z-index: 2;
  }

  // 悬浮二维码按钮的外层容器，不参与内部层级控制
  .float-qrcode-wrapper {
    position: static;
    z-index: auto;
  }
  
  // banner-buttons 样式，使用深度选择器确保在 Banner 组件内正确应用
  ::v-deep .banner-container {
    position: relative;
    
    .banner-buttons {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 65px;
      display: flex;
      flex-direction: row;
      gap: 20px;
      z-index: 5;
      
      .btn {
        width: 264px;
        height: 87px;
        background: url('~@/assets/image/city-btn.png') no-repeat center center;
        background-size: contain;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 30px;
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }
}
</style>
